import { render, staticRenderFns } from "./ScanRedirectPage.vue?vue&type=template&id=0ab6644a"
import script from "./ScanRedirectPage.vue?vue&type=script&lang=js"
export * from "./ScanRedirectPage.vue?vue&type=script&lang=js"
import style0 from "./ScanRedirectPage.vue?vue&type=style&index=0&id=0ab6644a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports